import { render, staticRenderFns } from "./MessageTextComp.vue?vue&type=template&id=39bb7c87&scoped=true"
import script from "./MessageTextComp.vue?vue&type=script&lang=js"
export * from "./MessageTextComp.vue?vue&type=script&lang=js"
import style0 from "./MessageTextComp.vue?vue&type=style&index=0&id=39bb7c87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb7c87",
  null
  
)

export default component.exports